import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { MovieProvider } from './context/MovieDatabaseContext'
import { RoutesHandeler } from './routeTree'

const queryClient = new QueryClient()

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <MovieProvider>
        <div className='container mx-auto'>
          <RoutesHandeler />
        </div>
      </MovieProvider>
    </QueryClientProvider>
  )
}
